import React, { useState } from 'react'
import './Exchange_Programs.css'
import White_Btn from '../../common_components/common_btn/white_btn/White_Btn'
import Red_Btn from '../../common_components/common_btn/red_btn/Red_Btn'
import Enquiry_Form_Modal from '../../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal'

const Exchange_Programs = () => {

    const [showModal, setShowModal] = useState(false)

    const data = [
        {
            label: "SINGAPORE",
            img: "/assets/images/home/exchange_program/img1.png"
        },
        {
            label: "Dubai",
            img: "/assets/images/home/exchange_program/img2.png"
        },
        {
            label: "Malaysia",
            img: "/assets/images/home/exchange_program/img3.png"
        },
    ];

    return (
      <>
        <div className="desktop_view_main_div">
          <section className="Exchange_Programs">
            <div className="container">
              <div className="red_bg_div">
                <div className="bg_img_holder">
                  <img
                    src="/assets/images/home/exchange_program/red_bg.png"
                    className="red_bg_img"
                  />
                </div>

                <div className="content_div">
                  <p className="exchange_text">Student Exchange Program</p>
                  <p className="yellow_text">in</p>
                  <p className="white_bold_text">
                    SINGAPORE , Dubai , Malaysia
                  </p>
                  {/* <p className='date_text'>1st – 6th July 2025</p> */}

                  <div className="btn_holder">
                    <White_Btn
                      btn_name="Register Now"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    />
                  </div>
                </div>

                <div className="left_side_section">
                  {data?.map((item) => {
                    return (
                      <div className="outer_div">
                        <div className="img_holder">
                          <img
                            src={process.env.PUBLIC_URL + item?.img}
                            className="img"
                          />

                          <div className="red_div">
                            <p className="white_text">{item?.label}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="right_side_card">
                  <p className="dear_text">Dear Learners,</p>
                  <p className="black_bold_text">
                    Get Ready to Go Global — Virtually!
                  </p>
                  <p className="bottom_text">
                    5 Nights / 6 Days Virtual Student Exchange Program,{" "}
                    <span className="inner_bold_text">
                      Singapore, Dubai , Malaysia!
                    </span>
                  </p>

                  {/* <p className='red_bold_text'>1st July – 6th July 2025</p> */}
                  <p className="dear_text">
                    Experience global industry exposure
                  </p>
                  <p className="last_text">
                    right from the comfort of your home!
                  </p>

                  <div className="btn_holder">
                    <Red_Btn
                      btn_name="Register Today"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="mobile_view_main_div">
          <section className="Exchange_Programs">
            <div className="container">
              <div className="red_bg_div">
                <div className="bg_img_holder">
                  <img
                    src="/assets/images/home/exchange_program/red_bg.png"
                    className="red_bg_img"
                  />
                </div>

                <div className="content_div">
                  <p className="exchange_text">Student Exchange Program</p>
                  <p className="yellow_text">in</p>
                  <p className="white_bold_text">
                    SINGAPORE , Dubai , Malaysia
                  </p>
                  {/* <p className='date_text'>1st – 6th July 2025</p> */}

                  <div className="btn_holder">
                    <White_Btn btn_name="Register Now" />
                  </div>
                </div>
              </div>

              <div className="left_side_section">
                {data?.map((item) => {
                  return (
                    <div className="outer_div">
                      <div className="img_holder">
                        <img
                          src={process.env.PUBLIC_URL + item?.img}
                          className="img"
                        />

                        <div className="red_div">
                          <p className="white_text">{item?.label}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="right_side_card">
                <p className="dear_text">Dear Learners,</p>
                <p className="black_bold_text">
                  Get Ready to Go Global — Virtually!
                </p>
                <p className="bottom_text">
                  5 Nights / 6 Days Virtual Student Exchange Program,{" "}
                  <span className="inner_bold_text">
                    Singapore, Dubai , Malaysia!
                  </span>
                </p>

                {/* <p className='red_bold_text'>1st July – 6th July 2025</p> */}
                <p className="dear_text">Experience global industry exposure</p>
                <p className="last_text">
                  right from the comfort of your home!
                </p>

                <div className="btn_holder">
                  <Red_Btn btn_name="Register Today" />
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* <Enquiry_Form_Modal
                show={showModal}
                onHide={() => { setShowModal(false) }}
            /> */}
      </>
    );
}

export default Exchange_Programs
